import ContentArchiveMultiple from 'components/contentArchive/multiple';
import SearchArchive from 'components/contentArchive/search';
import DefaultContentArchive from 'components/contentArchive/default';
import AuthorArchive from 'components/contentArchive/author';
import DefaultPage from 'components/contentItem/page/default';
import DefaultListViewItem from 'components/contentListViewItem/default';
import DefaultContentItem from 'components/contentItem/default';
import Homepage from 'components/landingPage/homepage';
import DefaultLandingPage from 'components/landingPage/default';
import Page from 'components/contentItem/page';
import ContentItem from 'components/contentItem';
import ContentArchive from 'components/contentArchive';
import LandingPage from 'components/landingPage';

import {
  TERM_ARCHIVE,
  SEARCH_ARCHIVE,
  AUTHOR_ARCHIVE,
  CATEGORY_ARCHIVE,
  CONTENT_ARCHIVE,
  CONTENT_ITEM_SINGLE,
} from 'config/types/path';

import { HOMEPAGE } from 'config/types/landingPage';

import {
  POST,
  PAGE,
  LANDING,
} from './';

export const ARCHIVE = 'archive';
export const SINGLE = 'single';
export const LIST_VIEW_ITEM = 'listViewItem';

export const typeOverride = {
  [ARCHIVE]: {
    [TERM_ARCHIVE]: () => ContentArchiveMultiple,
  },
};

export const componentOverride = {
  [LANDING]: {
    [SINGLE]: (match, item) => {
      switch (item.metadata.landingPageType) {
        case HOMEPAGE:
          return Homepage;

        default:
          return DefaultLandingPage;
      }
    },
  },
};

export const typeMap = {
  [ARCHIVE]: {
    [CONTENT_ARCHIVE]: DefaultContentArchive,
    [AUTHOR_ARCHIVE]: AuthorArchive,
    [CATEGORY_ARCHIVE]: ContentArchiveMultiple,
    [TERM_ARCHIVE]: ContentArchiveMultiple,
    [SEARCH_ARCHIVE]: SearchArchive,
  },
  [SINGLE]: {
    [CONTENT_ITEM_SINGLE]: DefaultContentItem,
  },
  [LIST_VIEW_ITEM]: DefaultListViewItem,
};

export const componentMap = {
  [POST]: {},
  [PAGE]: {
    [SINGLE]: DefaultPage,
  },
};

// Defines the container component to render for each path type.
export const containerMap = {
  SEARCH_ARCHIVE: ContentArchive,
  AUTHOR_ARCHIVE: ContentArchive,
  CONTENT_ARCHIVE: ContentArchive,
  CATEGORY_ARCHIVE: ContentArchive,
  TERM_ARCHIVE: ContentArchive,
  CONTENT_ITEM_SINGLE: ContentItem,
  HOME: LandingPage,
  PAGE: Page,
};
